import clsx from 'clsx';
import Icon from 'components/atoms/Icon';
import { copyTextToClipboard } from 'helpers/clipboard';
import { useState } from 'react';
import { Button } from '@spotted-zebra-uk/ui-components';
import styles from './CopyButton.module.scss';

const CopyButton = ({
  textToCopy,
  className,
}: {
  textToCopy: string;
  className?: string;
}) => {
  const [linkFreshlyCopied, setLinkFreshlyCopied] = useState(false);

  const handleCopyLink = () => {
    if (linkFreshlyCopied) return;
    copyTextToClipboard(textToCopy);
    setLinkFreshlyCopied(true);

    setTimeout(() => {
      setLinkFreshlyCopied(false);
    }, 2000);
  };

  return (
    <Button
      variant="tertiary"
      size="small"
      leftIcon={<Icon icon={linkFreshlyCopied ? 'check' : 'copy'} />}
      onClick={handleCopyLink}
      className={clsx(styles.copyButtonContainer, className)}
    />
  );
};

export default CopyButton;
